export const eulaAgreementConstants = {
  needsToAgree: 'needsToAgree',
  agreed: 'agreed',
  waitingForApiResponses: 'waitingForApiResponses',
} as const;
